<template>
    <div id="leftNav">
        <el-menu style="font-size: 16px;margin-top:12px;" :default-active="$route.meta.index">
            <div v-for="item in computed__menuList" :key="item.title" style="margin-bottom: 30px">
                <div index="1" class="menu-title">
                    <icon-svg :icon-class="item.iconClass" style="width:20px;height:20px;"></icon-svg>
                    <span class="nav-title" style="color: rgb(51, 51, 51); font-weight: bold;">{{item.title}}</span>
                </div>
                <el-menu-item
                    v-for="el in item.content"
                    :key="el.title"
                    :index="el.index"
                    @click="changeNav(el.path)"
                >
                    <span slot="title" class="menuTitle">{{el.title}}</span>
                </el-menu-item>
            </div>
        </el-menu>
    </div>
</template>
<script>
export default {
    data () {
        return {
            menuList: [
                {
                    iconClass: 'onlineStudy',
                    title: '在线学习',
                    control: ['2', '3'],
                    content: [
                        { index: '12', title: '常规课程', icon: 'mockTest', path: '/trainClass/personalCenter/learnCenter/mockTest', control: ['2', '3'] },
                        { index: '1', title: '培训班', icon: 'ClassSoftware', path: '/trainClass/personalCenter/learnCenter/classSoftware', control: ['2', '3'] },
                        { index: '9', title: '排行榜', icon: 'paihang', path: '/trainClass/personalCenter/accountInfo/ranking', control: ['2', '3'] },
                        { index: '8', title: '学习记录', icon: 'studyMsg', path: '/trainClass/personalCenter/accountInfo/studyLog', control: ['2', '3'] },
                        { index: '13', title: '模测成绩', icon: 'mockResult', path: '/trainClass/personalCenter/mockResultStudent', control:  ['2', '3'] },
                    ]
                },
                {
                    iconClass: 'teachManage',
                    title: '教学管理',
                    control: ['1', '3'],
                    content: [
                        { index: '11', title: '培训班管理', icon: 'trainClassManage', path: '/EducationManagemant/trainClassManage', control: ['1', '3'] },
                        { index: '14', title: '模测成绩', icon: 'mockResult', path: '/EducationManagemant/mockResultTeacher', control: ['1', '3'] },
                    ]
                },
                {
                    iconClass: 'mine',
                    title: '我的',
                    control: ['1', '2', '3'],
                    content: [
                        { index: '5', title: '个人信息', icon: 'trainClassManage', path: '/trainClass/personalCenter/accountInfo/personalInfo' },
                        { index: '7', title: '账户安全', icon: 'mockResult', path: '/trainClass/personalCenter/accountInfo/accountSafty' }
                    ]
                }
            ]
        }
    },
    computed: {
        btnsStatus () {
            return sessionStorage.btnsStatus
        },
        computed__menuList() {
            return this.menuList.filter(el => el.control.includes(this.btnsStatus))
        }
    },
    methods: {
        changeNav (route) {
            this.getUnreadMessage()
            this.getReadMessage()
            this.$router.push(route)
        },
        getUnreadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 1,
                        pageNumber: 1,
                        pageSize: 10
                    })
                )
                .then((res) => {
                    if (res.code === '200') {
                        this.$store.commit('unreadList', res.data.list)
                        this.$store.commit('unreadMessage', res.data.totalCount)
                    }
                })
        },
        getReadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 0,
                        pageNumber: 1,
                        pageSize: 10
                    })
                )
                .then((res) => {
                    if (res.code === '200') {
                        this.$store.commit('readList', res.data.list)
                        this.$store.commit('readTotal', res.data.totalCount)
                    }
                })
        },
    },
}
</script>

<style lang="scss">
#leftNav {
  min-height: 600px;
  position: fixed;
  height: 100%;
  .menu-title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 10px 13px 0px;
  }

  .nav-title {
      margin-left: 10px;
      width: 64px;
  }
  .el-menu {
    width: 180px;
    border: none;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    background: none;
  }
  .el-menu-item:hover() span {
    color: #409eff !important;
  }
  background-color: #ffffff;
  .el-menu-item.is-active {
    color: #0e86db;
  }
  .el-menu-item span {
    margin-left: 60px;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 30px;
    line-height: 30px;
  }
  .el-button--text {
    color: black;
  }
  .el-button {
    display: block;
    margin-left: 10px;
    height: 30px;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/leftNav.vue